export default __webpack_public_path__ + "assets/imgs/bege_preto_3_top_left_bottom_right.85dbab2b.png";